import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  InputGroup,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import EmailTemplateService from "../../../services/KangarooServices/EmailTemplateService";
import { formatDateTime } from "../../../Components/Common/FormatDate";
import toast from "react-hot-toast";
import DeleteModal from "../../../Components/Common/DeleteModal";

const EmailTemplate = () => {
  const navigate = useNavigate();
  const [courseData, setCourseData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
  const fetchData = async () => {
    try {
      const data = await EmailTemplateService.getList();

      setCourseData(data);
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await EmailTemplateService.delete(selectedDeleteItem.id);
        toast.success("Course deleted successfully");
        await fetchData();
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete Course",
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Email Templates" pageTitle="User Management" />
        {/* <Row className="mb-2">
         
          <Col
            md={12}
            xs={12}
            lg={12}
            className="d-flex justify-content-end align-items-end mb-2"
          >
            <Button
              className="btn btn-success"
              onClick={() => navigate("/email-template/create")}
            >
              + Create Template
            </Button>
          </Col>
        </Row> */}
        <Row className="g-4">
          {courseData?.map((item) => (
            <Col lg={4} md={6} sm={12} key={item.id}>
              <Card className="h-100 shadow-sm">
                <CardBody className="d-flex flex-column">
                  <div className="d-flex justify-content-between">
                    <small className="text-muted">
                      {formatDateTime(item?.createdDate)}
                    </small>

                    <div className="mb-2">
                      {item.isActive ? (
                        <Badge color="success">Active</Badge>
                      ) : (
                        <Badge color="secondary">Inactive</Badge>
                      )}
                    </div>
                  </div>
                  <h5 className="mb-2">{item.subject}</h5>
                  <div className="mb-2">
                    <Badge color="info" className="me-1">
                      {item.templateTypeName}
                    </Badge>
                  </div>
                  {item.placeholders.length > 0 && (
                    <p className="mb-3 text-muted">
                      Placeholders: {item.placeholders.join(", ")}
                    </p>
                  )}
                  <div className="mt-auto d-flex justify-content-end align-content-center align-items-center gap-2">
                    <Button
                      color="info"
                      size="sm"
                      onClick={() => navigate(`/email-template/${item?.id}`)}
                    >
                      <i class="ri-eye-line"></i>
                    </Button>
                    <Button
                      color="warning"
                      size="sm"
                      onClick={() =>
                        navigate(`/email-template/update/${item?.id}`)
                      }
                    >
                      <i className="ri-edit-line" />
                    </Button>
                    {/* <Button
                      className="btn btn-soft-danger btn-sm"
                      color="danger"
                      size="sm"
                      onClick={() => handleDeleteClick(item)}
                    >
                      <i className="ri-delete-bin-5-line" />
                    </Button> */}
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default EmailTemplate;
